import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { includes } from "lodash-es";
import {
  availableConversationTypesSelector,
  conversationTypeSelector,
  isAdministratorSelector,
  isAssignModeSelector,
  isSupervisorSelector,
  loadedInitSelector,
  selectedPhoneNumberSelector,
} from "appredux/selectors";
import { setChat, setConversationType } from "appredux/chatSlice";

// Jaga tab inbox (conversation_type) selalu tersedia di channel terpilih —
// terutama saat channel berganti (sidebar, link chat di kontak/tiket, dll).
// Tab sekarang dipertahankan jika tersedia; jika tidak, pakai default channel
// (sama dengan saat load inits: supervisor (roles 1) / admin → "all", selain
// itu → "my_inbox"). Tanpa ini tab channel lama ikut terbawa, mis. agen tetap
// di tab "all" setelah pindah dari channel tempat dia supervisor.
// Chat terpilih ikut dikosongkan (sama dengan klik tab di filterConversation)
// supaya panel kanan tidak menampilkan conversation dari tab lama.
const useSyncConversationType = () => {
  const dispatch = useDispatch();
  const loadedInit = useSelector(loadedInitSelector);
  const selectedPhoneNumber = useSelector(selectedPhoneNumberSelector);
  const conversationType = useSelector(conversationTypeSelector);
  const isAssignMode = useSelector(isAssignModeSelector);
  const isSupervisor = useSelector(isSupervisorSelector);
  const isAdministrator = useSelector(isAdministratorSelector);
  const availableTypes = useSelector(availableConversationTypesSelector);

  useEffect(() => {
    if (!loadedInit || !isAssignMode || !selectedPhoneNumber?.id) return;
    if (includes(availableTypes, conversationType)) return;

    dispatch(
      setConversationType(isSupervisor || isAdministrator ? "all" : "my_inbox"),
    );
    dispatch(setChat({ conversation: null, messages: [] }));
  }, [
    loadedInit,
    selectedPhoneNumber?.id,
    conversationType,
    isAssignMode,
    isSupervisor,
    isAdministrator,
    availableTypes,
    dispatch,
  ]);
};

export default useSyncConversationType;
